var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModeration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 1.75H12.25M3.75 14.25H12.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 1.75V3.6C4.75 4.5 5.2 5.34 5.95 5.84L8 7.2L10.05 5.84C10.8 5.34 11.25 4.5 11.25 3.6V1.75M4.75 14.25V12.4C4.75 11.5 5.2 10.66 5.95 10.16L8 8.8L10.05 10.16C10.8 10.66 11.25 11.5 11.25 12.4V14.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 13.4C6.05 12.75 6.5 12.2 7.1 11.9L8 11.45L8.9 11.9C9.5 12.2 9.95 12.75 10.1 13.4H5.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeration);
export default __webpack_public_path__ + "static/media/moderation.8ee7701d7c59c398b35be56f54779883.svg";
export { ForwardRef as ReactComponent };